import {Col, Row} from 'react-bootstrap'
import ReactCalendar from 'react-calendar'
import TripCard from './TripCard'
import {fetchDailyTrips} from '../liveTrip/api'
import {useState} from 'react'
import {useQuery} from 'react-query'
import {format} from 'date-fns'
import CustomSelect from '../../../components/formikControl/advancedSelect/Custom'
import {fetchDriverList} from '../driver/api'
import 'react-calendar/dist/Calendar.css'
import EmptyTrip from './EmptyTripView'
import {Driver} from '../../ts/driver'
import {RunnerBall} from '../../../components/FormLoader'

function TripHistory() {
  const [selectedDate, setSelectedDate] = useState(format(new Date(), 'yyyy-MM-dd'))
  const [driver, setDriver] = useState<Driver | null>(null)

  const {data: trips, isFetching: isFetchingTrips} = useQuery(
    ['busLocations', selectedDate],
    () => fetchDailyTrips(selectedDate),
    {
      refetchOnWindowFocus: false,
      staleTime: 60 * 1000,
    }
  )
  const {data: drivers, isLoading: loadingDrivers} = useQuery({
    queryKey: 'drivers',
    queryFn: () => fetchDriverList(),
    refetchOnWindowFocus: false,
  })

  const filteredTrips = trips?.data?.filter((trip) => {
    return driver?.driver_id ? trip.driver_id === driver?.driver_id : true
  })

  return (
    <Row>
      <Col sm="7">
        <div className="trip-history">
          <ReactCalendar
            className="fs-2 w-100"
            value={new Date(selectedDate)}
            onClickDay={(date) => setSelectedDate(format(date, 'yyyy-MM-dd'))}
          />
        </div>
      </Col>
      <Col sm="5" className="ps-8">
        <div className="fs-3 mb-3 d-flex justify-content-between align-items-center">
          <span>Trips on {format(selectedDate, 'dd-MM-yyyy')}</span>
          <div style={{minWidth: '150px', maxWidth: '220px', fontSize: '13px'}}>
            <CustomSelect
              onChange={(selected: any, action: any) => {
                action.action === 'clear' ? setDriver(null) : setDriver(selected)
              }}
              isLoading={loadingDrivers}
              options={drivers?.data}
              optionValue="driver_id"
              optionLabel="driver_name"
              size="sm"
              className="w-100"
              placeholder="Select Driver"
            />
          </div>
        </div>
        <div style={{height: '70vh', overflow: 'auto'}}>
          {isFetchingTrips ? (
            <RunnerBall />
          ) : filteredTrips!?.length > 0 ? (
            filteredTrips?.map((trip) => <TripCard tripData={trip} key={trip.daily_trip_id} />)
          ) : (
            <EmptyTrip date={selectedDate} driver={driver?.driver_name} />
          )}
        </div>
      </Col>
    </Row>
  )
}

export default TripHistory
